// extracted by mini-css-extract-plugin
var _1 = "Styles_fontFamily__ccb2b";
export { _1 as "fontFamily" }
